module.exports = __webpack_public_path__ + "img/baterry_confirmation.a177c89d.png";